import React, {  useState, useEffect } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import axiosInstance from "Api";
import DefaultModal from "Components/Modal/DefaultModal"
import { ReactComponent as DeleteIcon } from "../../../assets/utils/images/svgs/Delete.svg";
import ReactTableGeneric from "Components/ReactTableGeneric";

export const DeviceModal = ({ modal, userDetails, modalHandler, reporterId, refetchUserList }) => {
    const [showDeviceAlert, setShowDeviceAlert] = useState(false);
    const [deleteAlert, setDeleteAlert] = useState(false);
    const [tokenToDelete, setTokenToDelete] = useState(null);
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        if (userDetails?.tokensList?.length > 0) {
            const tokensList = userDetails.tokensList;
            const deviceTable = tokensList.map((device) => {
                const dateObj = new Date(device.created_at);

                return {
                    vDeviceBrand: device.vDeviceBrand || '',
                    vDeviceModel: device.vDeviceModel || '',
                    vFcmToken: device.vFcmToken,

                    createdAtTs: dateObj.getTime(),

                    createdAtDisplay: `${String(dateObj.getDate()).padStart(2, '0')}-${String(
                        dateObj.getMonth() + 1
                    ).padStart(2, '0')}-${dateObj.getFullYear()} ${String(
                        dateObj.getHours()
                    ).padStart(2, '0')}:${String(dateObj.getMinutes()).padStart(2, '0')}:${String(
                        dateObj.getSeconds()
                    ).padStart(2, '0')}`,

                    actions: device.vFcmToken,
                };
            });

            setTableData(deviceTable);
            setShowDeviceAlert(false);
        } else {
            setTableData([]);
            if (modal.type === 'DEVICE_MODAL' && modal.state) setShowDeviceAlert(true);
        }

    }, [userDetails, reporterId, modal]);

    const columns = React.useMemo(
        () => [
            {
                header: () => 'Brand',
                accessorKey: 'vDeviceBrand',
            },
            {
                header: () => 'Model',
                accessorKey: 'vDeviceModel',

            },
            {
                header: () => 'Fcm Tokens',
                accessorKey: 'vFcmToken',
                cell: ({ row }) => {
                    const token = row.original.vFcmToken;
                    return token ? token.substring(0, 6) + '...' : '-';
                }
            },

            {
                header: () => 'Created At',
                accessorKey: 'createdAtTs',
                cell: ({ row }) => row.original.createdAtDisplay,

            },
            {
                header: "Delete",
                accessorKey: "actions",
                id: "actions",
                disableSortBy: true,

                cell: ({ cell }) => {
                    return (
                        <div >
                            <button
                                className="btn btn-link p-0 text-danger text-center"
                                onClick={() => handleDeleteDevice(cell.row.original.vFcmToken)}
                                title="Delete Device"
                            >
                                <DeleteIcon className="cursor-pointer" />
                            </button>
                        </div>
                    );
                },

            }
        ],
        [tableData]
    );

    const handleDeleteDevice = (fcmToken) => {
        setDeleteAlert(true);
        setTokenToDelete(fcmToken);
    };

    const onDeleteConfirm = async () => {
        if (tokenToDelete) {
            try {
                const iAdminId = userDetails?.iAdminId;
                const payload = {
                    iAdminId,
                    vFcmToken: tokenToDelete,
                };

                const response = await axiosInstance.post('/user/delete-fcm-token', payload);
                if (response.status === 200) {

                    setTableData(prev =>
                        prev.filter(device => device.actions !== tokenToDelete)
                    );
                    refetchUserList();
                }
            } catch (error) {
                console.error("Error deleting device:", error);
            }
        }
        setDeleteAlert(false);
    };

    const onCancel = () => {
        setDeleteAlert(false);
    };

    return <>
        {
            tableData?.length > 0 ? (
                <DefaultModal
                    modal={modal.type === 'DEVICE_MODAL' && modal.state}
                    toggle={() => modalHandler((prev) => ({ ...prev, type: 'USER_MODAL' }))}
                    showFooterBtns={false}
                    header={`Apparaten van Alle Merken`}
                    classes="modal-dialog__over feedback-modal-style modal-color custom-device-modal"
                    headerColor="modal-header-color"
                >
                    <div className="table-scroll-container">
                        <ReactTableGeneric
                            search={false}
                            data={tableData}
                            rowCount={100}
                            columns={columns}
                            tableClassName="mb-0 table table-borderless table-sm table-hover"
                            filters={{ search: false, pagination: false, sorting: false }}
                          
                        />
                    </div>

                    {
                        deleteAlert && (
                            <SweetAlert
                                title="Weet je zeker dat je wilt verwijderen?"
                                show={deleteAlert}
                                type="warning"
                                onCancel={onCancel}
                                onConfirm={onDeleteConfirm}
                                cancelBtnText="Nee"
                                confirmBtnText="Ja"
                                showCancel={true}
                            />
                        )
                    }
                </DefaultModal>) : (
                <SweetAlert
                    title="Niet ingelogd op een mobiel apparaat."
                    show={showDeviceAlert}
                    type="warning"
                    onConfirm={() => { setShowDeviceAlert(false); modalHandler({ type: 'USER_MODAL', state: true }) }}
                    confirmBtnText="OK"
                />
            )
        }
    </>

}

